import React from "react";
import injectSheet from "react-jss";
import Icon from "../../assets/icons/Icon";
import { globalTheme } from "../../styles/globalTheme";

const Forwardbutton = ({
  classes,
  children,
  type,
  disabled,
  name,
  onClick,
  id,
  cy_id,
  value,
}) => (
  <div>
    <button
      type={type ? type : "button"}
      disabled={disabled === true ? true : false}
      className={
        disabled === true
          ? classes.forwardButtonDisabled
          : classes.forwardButton
      } //{classes.forwardButton}
      name={name ? name : ""}
      onClick={disabled === true ? () => {} : onClick}
      id={id}
      data-cy={cy_id}
      value={value ? value : ""}
    >
      <div style={{ marginTop: "2px", marginRight: "4px" }}>{children}</div>

      <Icon
        type="arrow"
        rotate="180"
        width="24px"
        disabled={disabled === true ? true : false}
        disabledColor="#8f919d"
        fill="white"
      />
    </button>
  </div>
);

const styles = (theme) => ({
  forwardButton: {
    padding: "7px 7px 7px 16px",
    backgroundColor: theme.actionButtonColor, //"#335cda",
    border: 0,
    borderRadius: "4px",
    fontSize: "16px",
    color: "#fff",
    minWidth: "122px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: theme.themeHoverColor, //"#182d58"
      color: theme.themeHoverTextColor,
      "& svg g polygon": {
        fill: `${theme.themeHoverTextColor}!important`, //"#8f919d!important",
      },
      "& svg path": {
        fill: `${theme.themeHoverTextColor}!important`, //"#8f919d!important",
      },
      "& svg rect": {
        fill: `${theme.themeHoverTextColor}!important`, //"#8f919d!important",
      },
    },
    "&:focus": {
      outline: globalTheme.outline,
      outlineOffset: "2px",
    },
  },
  forwardButtonDisabled: {
    padding: "7px 7px 7px 16px",
    backgroundColor: theme.actionButtonColor, //"#335cda",
    border: 0,
    borderRadius: "4px",
    fontSize: "16px",
    color: "#fff",
    minWidth: "122px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  "@media (max-width: 1023px)": {
    forwardButton: {
      cursor: "none",
      width: "100%",
      "&:hover": {
        background: theme.actionButtonColor, //"#335cda"
      },
    },
  },
});
export default injectSheet(styles)(Forwardbutton);
